import React from 'react';
import { Card, Descriptions, Typography } from 'antd';

const { Text } = Typography;

export interface EpcEstimateIntelligenceRailProps {
  estimateNumber?: string;
  revisionLabel?: string;
  tenderTitle?: string;
  revisionCount?: number;
  boqLineCount?: number;
  costLineCount?: number;
}

export const EpcEstimateIntelligenceRail: React.FC<EpcEstimateIntelligenceRailProps> = ({
  estimateNumber,
  revisionLabel,
  tenderTitle,
  revisionCount = 0,
  boqLineCount = 0,
  costLineCount = 0,
}) => (
  <Card size="small" title="Estimate intelligence">
    <Descriptions size="small" column={1}>
      <Descriptions.Item label="Estimate">{estimateNumber || '—'}</Descriptions.Item>
      <Descriptions.Item label="Revision">{revisionLabel || '—'}</Descriptions.Item>
      <Descriptions.Item label="Tender">{tenderTitle || '—'}</Descriptions.Item>
      <Descriptions.Item label="Revisions">{revisionCount}</Descriptions.Item>
      <Descriptions.Item label="BOQ lines">{boqLineCount}</Descriptions.Item>
      <Descriptions.Item label="Cost lines">{costLineCount}</Descriptions.Item>
    </Descriptions>
    <Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 8 }}>
      Lineage and AI brief hooks — Wave 6+
    </Text>
  </Card>
);
